import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Add, Edit } from "@mui/icons-material";
import axiosInstance from "../../utils/axiosInstance";
import { deliverySlotsUrl } from "../../utils/urls";
import CustomDataGrid from "../../components/tables/CustomDataGrid";
import moment from "moment/moment";
import ServerPaginationDataGrid from "../../components/tables/ServerPaginationDataGrid";
import PageHeader from "../../components/page-layout/PageHeader";

const DeliverySlots = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => (
        <Typography>{params.row.name?.trim() || "-"}</Typography>
      ),
    },
    {
      field: "startTime",
      headerName: "Start Time",
      width: 180,
      renderCell: ({ row }) => (
        <Typography>
          {moment(row.startTime, "HH:mm:ss").format("hh:mm A")}
        </Typography>
      ),
    },
    {
      field: "closeTime",
      headerName: "Close Time",
      width: 180,
      renderCell: ({ row }) => (
        <Typography>
          {moment(row.closeTime, "HH:mm:ss").format("hh:mm A")}
        </Typography>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: ({ row }) => (
        <Button
          onClick={() => navigate(`edit/${row.id}`)}
          startIcon={<Edit />}
          size="small"
        >
          Edit
        </Button>
      ),
    },
  ];

  return (
    <Stack spacing={2}>
      <PageHeader
        title={"Delivery Slots"}
        lead={"Manage and configure the available delivery time slots for your customers."}
        buttonTitle={"Add Delivery Slot"}
        buttonOnClick={() => navigate("add")}
        showBack={true}
      />

      <ServerPaginationDataGrid
        columns={columns}
        name="delivery-table"
        pagination
        paginationMode="client" 
        pageSize={10}
        autoHeight
        url={deliverySlotsUrl}
      />
    </Stack>
  );
};

export default DeliverySlots;
